import React from "react";
import styles from "./PhoneButtonSection.scss";
import SummaryButtons from "../../SummarySection/SummaryButtons";
import { getIconUrl } from "../../../../../services/asset";
import { externalPartner } from "../../../AdDetailsPageWeb/SellerSection/SellerSection";
import { Button } from "antd";
import { creatorInterface, UserI } from "../../../../../typings/interfaces";
import ReactGA from "react-ga4";

export interface PhoneButtonSectionProps {
  seller: creatorInterface;
  hasPhones: boolean;
  externalUrl: string;
  onCallPhoneClick: () => void;
  onReportOpen: () => void;
  onChatClick: () => void;
  adId?: string;
  adTitle?: string;
  user: any;
}

const PhoneButtonSection = (props: PhoneButtonSectionProps) => {
  const {
    seller,
    hasPhones,
    externalUrl,
    onCallPhoneClick,
    onReportOpen,
    adId,
    adTitle,
    onChatClick,
    user,
  } = props;
  return (
    <React.Fragment>
      <SummaryButtons
        hasPhones={hasPhones}
        onCallPhoneClick={onCallPhoneClick}
        seller={seller}
        adId={adId}
        adTitle={adTitle}
        onChatClick={onChatClick}
        user={user}
      />
      {externalPartner == seller.username && (
        <Button
          className={styles.externalLink}
          target="_blank"
          type="ghost"
          href={externalUrl}
          onClick={() => {
            ReactGA.event({
              category: "Turizam",
              action: "Click",
              label: "Rezerviraj iz oglasa"
            });
          }}
        >
          {"Rezerviraj"}
        </Button>
      )}
      <div
        role="button"
        tabIndex={0}
        // @ts-ignore
        type="button"
        className={styles.button}
        onClick={onReportOpen}
      >
        <img
          alt={"Prijavi oglas"}
          src={getIconUrl("flag.svg")}
        />
        {"Prijavi oglas"}
      </div>
    </React.Fragment>
  )
};

PhoneButtonSection.defaultProps = {
  seller: {
    username: null,
  },
  hasPhones: false,
  externalUrl: null,
  onCallPhoneClick: () => null,
  onReportOpen: () => null,
};

export default PhoneButtonSection;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/ContactSection/PhoneButtonSection/index.tsx